module.exports = __webpack_public_path__ + "static/media/logout.5777cf0c.svg";